module.exports = __webpack_public_path__ + "static/img/105.d1da2cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/105.jpg
// module id = rH0h
// module chunks = 0